// extracted by mini-css-extract-plugin
export var bg = "DVertResidenceClub-module--bg--d5dba";
export var core = "DVertResidenceClub-module--core--cbb59";